import app from '../main.js'

export function addOrdinalSuffix(number)
{
    const locale = app.$i18n.locale;

    let formattedResponse = number;

    switch (locale) {
        case 'en':
            formattedResponse = addOrdinalSuffixEnglish(number);
            break;
        case 'es':
            formattedResponse = addOrdinalSuffixSpanish(number)
            break;
        case 'fr':
            formattedResponse = addOrdinalSuffixFrench(number);
            break;
        // Add more cases as needed for other languages
        default:
            // By default, use English rules
            formattedResponse = addOrdinalSuffixEnglish(number);
    }

    return formattedResponse;
}

function addOrdinalSuffixEnglish(number)
{
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
        return number + "st";
    } else if (lastDigit === 2 && lastTwoDigits !== 12) {
        return number + "nd";
    } else if (lastDigit === 3 && lastTwoDigits !== 13) {
        return number + "rd";
    } else {
        return number + "th";
    }
}

function addOrdinalSuffixFrench(number)
{
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    switch (lastDigit) {
        case 1:
            return lastTwoDigits === 11 ? number + "ème" : number + "ère";
        case 2:
            return lastTwoDigits === 12 ? number + "ème" : number + "ème";
        default:
            return number + "ème";
    }
}

function addOrdinalSuffixSpanish(number) {
    return number + "º";
}
